/**
 * @Description: 不同型号打印机可用的耗材信息相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  PrinterMaterialsModel,
  PrinterMaterialsSearchModel,
  PrinterMaterialsPageSearchModel,
  PrinterMaterialsAddModel,
  PrinterMaterialsUpdateModel,
  IdsModel
} from '@/model/product/PrinterMaterialsModel'

const baseUrl = Route.product + '/printerMaterials'

/**
 * 搜索分页数据
 */
export const pageSearchPrinterMaterials = (param: PrinterMaterialsPageSearchModel) => {
  return https().request<RootObject<PageRespModel<PrinterMaterialsModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchPrinterMaterials = (param: PrinterMaterialsSearchModel) => {
  return https().request<RootObject<PrinterMaterialsModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getPrinterMaterials = (id: number) => {
  return https().request<RootObject<PrinterMaterialsModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addPrinterMaterials = (param: PrinterMaterialsAddModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.json)
}

/**
 * 更新数据
 */
export const updatePrinterMaterials = (param: PrinterMaterialsUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
}

/**
 * 删除数据
 */
export const removePrinterMaterials = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemovePrinterMaterials = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}
